import { makeActionCreator } from '../../../../utilities/makeActionCreator.util'
import { LabsConstants } from './labs.constants'

export const setDateTime = makeActionCreator(LabsConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(LabsConstants.SET_ASSESSED_BY, 'assessedBy')
export const setLabValue = makeActionCreator(LabsConstants.SET_LAB_VALUE, 'labName', 'value')
export const saveLabs = makeActionCreator(LabsConstants.SAVE_LABS)
export const setLabsState = makeActionCreator(LabsConstants.SET_STATE, 'labsState')
export const resetLabsState = makeActionCreator(LabsConstants.RESET_STATE)
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  LabsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  LabsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
